
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import { acceptInvit } from '../../Services/Users';
import { useTranslation } from 'react-i18next';

const Invitation: React.FunctionComponent<{}> = (props) => {

    const { id } = useParams()
    const [firstName, setFirstName] = useState<any>();
    const [lastName, setLasteName] = useState<any>();
    const [password, setPassword] = useState<any>();
    const [email, setEmail] = useState<any>();
    const [loading, setLoading] = useState(false);
    let navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        const user = "";
        acceptInvit(user, id).then((data) => {
            setLoading(false)
            setEmail(data.email)
        }).catch(err => {
            console.log("Error");
        });
    }, [])


    const handleChangeLastName = (event: any) => {
        setLasteName(event.target.value)
    }
    const handleChangeFirstName = (event: any) => {
        setFirstName(event.target.value)
    }
    const handleChangePassword = (event: any) => {
        setPassword(event.target.value)
    }

    const SignUp = () => {

        const user = {
            "firstName": firstName,
            "lastename": lastName,
            "statu": true,
            "password": password,
            "email": email
        }

        acceptInvit(user, id).then((data) => {
            navigate('/login')
        }).catch(err => {
            console.log("Error");
        });
    }

    return loading ? <div className="">Loading..</div> : (

        <div className="app-account1 ">
            <div className="login-marg">
                <div className="row">
                    <img src="/assets/images/icons/coralytics.webp" className='invit' />
                </div>
                <div className="title" style={{ color: " black", fontSize: "20px" }}> {t("invitation.invitedTitle")} </div>
                <div className="form">
                    <div className="mb-3">
                        <label htmlFor="email" className="form-label ">{t("propertyDetails.emailAddress")}</label>
                        <input type="text" className="form-control" name="email" placeholder={t("propertyDetails.emailAddress")} value={email} disabled />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="firstname" className="form-label ">{t("invitation.firstName")}</label>
                        <input type="text" className="form-control" name="firstname" placeholder='Name'
                            onChange={handleChangeFirstName} />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="lastname" className="form-label ">{t("invitation.lastName")}</label>
                        <input type="text" className="form-control" name="lastname" placeholder='Name'
                            onChange={handleChangeLastName} />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="password" className="form-label">{t("invitation.password")} </label>
                        <input type="password" className="form-control" name="password" placeholder='Password'
                            onChange={handleChangePassword} />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="confpassword" className="form-label">{("invitation.confirmPassword")}</label>
                        <input type="password" className="form-control" name="confpassword" placeholder='Password' />
                    </div>

                    <button type="submit" className='btn btn-primary' style={{ width: "100%" }} onClick={SignUp}>{("invitation.signUp")}</button>


                    <div className='row mt-3'>
                        <p>{t("invitation.byJoining")}<span>{t("invitation.termsOfService")}</span>  {t("invitation.and")} <span>{t("invitation.privacyPolicy")}</span></p>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default Invitation